module.exports = __webpack_public_path__ + "img/28.204005f8.png";